import { MODAL_REGISTER, MODAL_UPDATE, MODAL_CLOSE } from '../constants/ActionTypes';


export const registerModal = modal => ({
  type: MODAL_REGISTER,
  payload: modal,
});

export const updateModal = content => ({
  type: MODAL_UPDATE,
  payload: content,
});

export const closeModal = () => ({
  type: MODAL_CLOSE,
  payload: {},
});
